module.exports = "/static/images/bean.png";